<template>
    <div class="flex items-center">
        <template>
            <date-tooltip :data="data.created_at" />
        </template>
    </div>
</template>

<script>
export default {
    name: "KeywordCreatedat",
    props: {
        data: {
            type: Object,
            default: () => {}
        },
    },
    components: {  },
};
</script>

<style scoped lang="scss">

</style>
